import cluster_est from "../assets/img/marker/cluster_est.png";
import cluster_egg from "../assets/img/marker/cluster_egg.png";

export const MIDDLEWARE_API_URL = "https://lis.e-steiermark.com/sso/api/";
// export const MIDDLEWARE_API_URL = 'http://localhost:8000/api/';

export const GOOGLE_PLACES_API_URL =
  "https://maps.googleapis.com/maps/api/place/";
export const GOOGLE_PLACES_API_KEY = "AIzaSyC7NjdBb3EkZLTYtFgaBc68jHNwk-zuRBs";

export const REGION_HOME = {
  latitude: 47.0708678,
  longitude: 15.4382786,
  latitudeDelta: 0.25,
  longitudeDelta: 0.25,
};

let params = new URL(document.location).searchParams;

let PROVIDER = "EST";

if (params.get("provider") === "egg") PROVIDER = "EGG";
else if (params.get("provider"))
  PROVIDER = params.get("provider").toUpperCase();

// let COLOR_GREY = '#efefef';
let COLOR_PRIMARY = "#77b83a";
let COLOR_SECONDARY = "#d3d3d3";
let COLOR_DARK = "#666666";
let COLOR_LIGHT = "#FFFFFF";
let TITLE = "Emobil-Ladestellen";
let CLUSTER_ICON = cluster_est;

if (PROVIDER === "EGG") {
  COLOR_PRIMARY = "#00324d";
  COLOR_SECONDARY = "#d3d3d3";
  COLOR_DARK = "#0a8161";
  COLOR_LIGHT = "#FFFFFF";
  TITLE = "Ladestationen";
  CLUSTER_ICON = cluster_egg;
}

export {
  COLOR_PRIMARY,
  COLOR_SECONDARY,
  COLOR_DARK,
  COLOR_LIGHT,
  TITLE,
  CLUSTER_ICON,
  PROVIDER,
};
